import { Navigate, useOutlet } from 'react-router';

import { useAuthContext } from 'app/contexts/auth/context';
import { useAdminTenantContext } from 'app/contexts/adminTenant/context';
import { isUserAdmin } from 'hooks/useIsAdmin';

export default function AdminTenantGuard() {
  const outlet = useOutlet();
  const { user } = useAuthContext();
  const { hasSelectedTenant } = useAdminTenantContext();

  // Non-admin users use their own tenant from the JWT — pass through.
  if (!isUserAdmin(user)) {
    return <>{outlet}</>;
  }

  if (!hasSelectedTenant) {
    return <Navigate to="/select-tenant" replace />;
  }

  return <>{outlet}</>;
}
